var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c(
      "article",
      { staticClass: "card", attrs: { id: "tagId" + _vm.id } },
      [
        _c(
          "page-columns",
          { staticClass: "card__columns", attrs: { column_half: true } },
          [
            _c("template", { slot: "first" }, [
              _c(
                "div",
                { staticClass: "card__content" },
                [
                  _c("div", { staticClass: "card__meta" }, [
                    _c("span", { staticClass: "event-date" }, [
                      _vm._v(_vm._s(_vm.dateStr))
                    ])
                  ]),
                  _c(
                    "link-to",
                    { staticClass: "no_border", attrs: { to: _vm.linkTo } },
                    [_c("h3", { domProps: { innerHTML: _vm._s(_vm.title) } })]
                  ),
                  _c("div", { staticClass: "description font-size-1" }, [
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } }),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "link-to",
                          {
                            staticClass: "text-black solid",
                            attrs: { to: _vm.linkTo }
                          },
                          [_vm._v("Читать далее...")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ]),
            _c(
              "template",
              { slot: "last" },
              [
                _c(
                  "link-to",
                  { staticClass: "card__image", attrs: { to: _vm.linkTo } },
                  [
                    _c(
                      "div",
                      {
                        ref: "cover",
                        staticClass: "cover",
                        style: {
                          backgroundImage:
                            "url('" +
                            (this.isImages ? this.isImages : _vm.image) +
                            "')"
                        }
                      },
                      [
                        _c("div", { staticClass: "mobile-content" }, [
                          _c("div", { staticClass: "bg" }),
                          _c("h3", {
                            domProps: {
                              innerHTML: _vm._s(_vm.dateStr + " " + _vm.title)
                            }
                          }),
                          _c("div", { staticClass: "description" }, [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.text) }
                            })
                          ])
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cabecc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cabecc9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/cards/CardNewsSmall.vue
// module id = HC7t
// module chunks = 0 1 2 4 32